/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Save_To_Space_Overwrite_WarningInputs */



/**
* | output |
* | --- |
* | "A file already exists at this path. It is overwritten, and its current content is lost." |
*
* @param {Chat_Save_To_Space_Overwrite_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_overwrite_warning = /** @type {((inputs?: Chat_Save_To_Space_Overwrite_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_Overwrite_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unter diesem Pfad liegt bereits eine Datei. Sie wird überschrieben, ihr bisheriger Inhalt geht verloren.")
	return /** @type {LocalizedString} */ ("A file already exists at this path. It is overwritten, and its current content is lost.")
});